import { isDisabled } from "@testing-library/user-event/dist/utils";
import { useEffect, useState } from "react";
import Select from "react-select";

function CustomSelect(props) {
    let {
        options,
        handleChange = () => { },
        isMulti = false,
        value = "",
        labelKey,
        valKey,
        isSearchable = true,
        isClearaAble = true,
        label = "",
        errorMsg = "",
        isBottomBorder,
        size = "medium",
        placeholder = "",
        isDisabled = false
    } = props;

    options = options?.map((i) => ({
        label: i[labelKey],
        value: i[valKey],
        details: i
    }));

    const [selectedValue, setSelecteValue] = useState([]);

    const transformOption = (value) => {
        if (!value) return [];
        return value?.map((level) => ({
            value: level,
            label: level,
        }));
    };

    useEffect(() => {
        if (isMulti) {
            setSelecteValue(transformOption(value));
        }
    }, [value, isMulti]);


    const sizeStyles = {
        small1: { minHeight: "36px", fontSize: "var(--font-size-h4)" },
        small: { minHeight: "28px", fontSize: "var(--font-size-h4)" },
        medium: {
            minHeight: "36px", fontSize: "var(--font-size-base)"
        },
        large: { minHeight: "44px", fontSize: "var(--font-size-h3)" },
    };

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            border: isBottomBorder ? "none" : provided.border,
            borderBottom: isBottomBorder ? "1px solid #3a4b68" : provided.border,
            borderRadius: isBottomBorder ? 0 : provided.borderRadius,
            boxShadow: "none",
            minHeight: sizeStyles[size].minHeight,
            fontSize: sizeStyles[size].fontSize,
            "&:hover": {
                borderBottom: isBottomBorder
                    ? "1px solid #3a4b68"
                    : provided.borderBottom,
            },
        }),
        valueContainer: (provided) => ({
            ...provided,
            minHeight: sizeStyles[size].minHeight,

            padding: "6px 2px 6px 6px"
        }),
        placeholder: (provided) => ({
            ...provided,
            fontSize: "var(--font-size-base)", // or any size like "11px"
            color: "#667085",
        }),
        input: (provided) => ({
            ...provided,
            margin: 0,
            padding: 0,
        }),
        singleValue: (provided) => ({
            ...provided,
            color: '#3a4b68',
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: sizeStyles[size].minHeight,
        }),
        option: (provided, state) => ({
            ...provided,
            fontSize: "var(--font-size-base)",     // 👈 smaller font
            padding: "0px 2px",   // 👈 reduce padding
        }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    };


    return (
        <div>
            <label htmlFor="" className="labelForASsign form-label">
                {label}
            </label>
            <Select
                options={options}
                isSearchable={isSearchable}
                isClearable={isClearaAble}
                isDisabled={isDisabled}
                value={
                    isMulti
                        ? selectedValue
                        : options?.find((i) => i.value === value) || null
                }
                isMulti={isMulti}
                onChange={(e) => {
                    if (isMulti) {
                        let arr = e?.map((item) => item.value) || [];
                        handleChange(arr, e);
                        setSelecteValue(transformOption(arr));
                    } else {

                        handleChange(e?.value || "", e);
                    }
                }}
                closeMenuOnSelect={!isMulti}
                hideSelectedOptions={false}
                classNamePrefix="select"
                className="w-100"
                styles={customStyles}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                placeholder={placeholder}
            />
            <div className="text-danger font-size-h4">{errorMsg}</div>
        </div>
    );
}

export default CustomSelect;
